module.exports = __webpack_public_path__ + "img/phone_icon.b75e6224.svg";